<template>
<div style="color: black">
  <ul>
    <li>样本：全闭环化管理</li>
    <li>数据：生信一体化联网</li>
    <li>报告：全结构化采集</li>
    <li>解读：生信知识库</li>
  </ul>
</div>
</template>

<script>
export default {
  name: "CPZX"
}
</script>

<style scoped>

</style>
